import A11yDialog from 'a11y-dialog';
import { initRecaptcha } from '../lib/initRecaptcha';

function initDialog() {
	const dialogEl = document.getElementById('callback-dialog');
	if (!dialogEl) return;

	const dialog = new A11yDialog(dialogEl);

	// Init recaptcha when opening dialog
	const button = document.querySelector('.js-callback-dialog-button');
	if (!button) return;

	button.addEventListener('mouseover', () => {
		initRecaptcha();
	});

	dialog.on('show', () => {
		initRecaptcha();
	})
}

initDialog();
